import React, { Component } from "react";
import styled, { css } from "react-emotion";
import { FlexRow, Label, FlexColumn } from "appStyles";
import { SketchPicker } from "react-color";
import { withRedux } from "helpers";

const Container = styled("div")`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: "80px";
  position: relative;
  width: ${(props) => (props.width ? props.width : "100%")};
  margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom : 0)};
  /* border: 1px solid red; */
`;

const P = styled("p")`
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
  display: block;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 0.9375rem;
  line-height: 0.9375rem;
  display: flex;
  align-items: flex-end;
  letter-spacing: 0.4px;
`;

const Circle = styled("div")`
  cursor: pointer;
  border-radius: 20%;
  width: 50px;
  height: 50px;
  margin: 10px;
  /* border: 0.25px solid black; */
  box-shadow: rgba(120, 120, 120, 0.5) 3px 3px 13px;
  margin-left: ${(props) => props.marginLeft};
  background: ${(props) => props.color};
`;

const colorPicker = css`
  width: 227px;
  height: 80px;
  z-index: 2;
`;

class ColorPicker extends Component {
  state = {
    showPicker: true,
  };

  getPreviousColors = () => {
    let rx = /(?:#)[0-9a-f]{8}|(?:#)[0-9a-f]{6}|(?:#)[0-9a-f]{4}|(?:#)[0-9a-f]{3}/gi;
    return (
      this.props.activeApp.unpublishedView && [
        ...new Set(this.props.activeApp.unpublishedView.match(rx)),
      ]
    );
  };

  togglePicker = () => {
    const { showPicker } = this.state;
    this.setState({ showPicker: !showPicker });
  };

  closePicker = () => {
    this.setState({ showPicker: true });
  };

  onChange = (e) => {
    this.props.onChange(e.hex);
  };

  render() {
    const {
      color,
      title,
      zIndex,
      width,
      height,
      marginBottom,
      marginLeft,
    } = this.props;
    const { showPicker } = this.state;

    let fallBackColor;
    if (color) {
      fallBackColor = color;
    } else if (this.state.color) {
      fallBackColor = this.state.color;
    } else {
      fallBackColor = "#FFFFFF";
    }

    return (
      <Container
        style={{
          marginBottom: marginBottom ? marginBottom : "0px",
          width: width ? width : "100%",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <div style={{ display: "inline-block", float: "left" }}>
            <P>
              <Label style={{ width: "178px" }} title={title}>
                {title}
              </Label>
            </P>
          </div>
          <Circle
            style={{ display: "inline-block", marginLeft: marginLeft }}
            color={fallBackColor}
            onMouseEnter={this.togglePicker}
          />
        </div>
        <div
          className={colorPicker}
          style={{ zIndex, position: "absolute", marginLeft: "300px" }}
          onMouseLeave={this.closePicker}
        >
          <div hidden={showPicker}>
            <SketchPicker
              presetColors={this.getPreviousColors()}
              disableAlpha={true}
              color={fallBackColor}
              onChangeComplete={this.onChange}
            />
          </div>
        </div>
      </Container>
    );
  }
}

export default withRedux(ColorPicker);
